import template from './panel.component.html';
import { AiMarkerSetPanelController as controller } from './panel.controller';
import './style.less';

export default {
	bindings: {
		aiPrompts: '<',
		llmDefinitions: '<',
		activity: '<',
		canPreview: '<',
		title: '<?',
		onEdit: '&',
		onRemove: '&',
		onPreview: '&'
	},
	controller,
	require: {
		activityEditorController: '?^activityEditor'
	},
	template
} as ng.IComponentOptions;
